import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
    '[class.text-wrap]': 'textWrap',
    '[context-warning]': 'isWarning',
  },
})
export class MessageComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'context-information',
      'context-error',
      'context-warning',
      'context-success',
      'small',
      'no-padding',
    ],
  ];
  @ComponentVariant(MessageComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public textWrap: boolean = false;
  @Input() public isWarning: boolean = false;
}
